export default __webpack_public_path__ + "static/media/LiquidCrystal-Normal.eabe5738.woff";